import React, { useState, useEffect, useContext } from 'react';
import SimpleTable from '../../../components/tables/simpleTable';
import TrashModal from '../../../components/modals/trashModal';
import RecoverModal from '../../../components/modals/recoverModal';
import AddModal from '../../../components/modals/addModal';
import EditModal from '../../../components/modals/editModal';
import SearchFilter from '../../../components/filters/search';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import Loader from '../../../components/loader/loader';
import { Col, Form, Row } from 'react-bootstrap';
import { DataContext } from '../../../init/getData';
import { Modal, Button } from 'antd';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { isAuxFormatter, natureFormatter, natureTextFormatter } from '../../../components/formatters/defFormatter';


function ChartTable(props) {

  let { } = props;


  const { userData, settingData, serverApi, api, refChartData, chartData } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isChart: 'true' });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);


  const [account, setAccount] = useState([]);


  const table = 'chart';
  const title = 'Account';


  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);




  // Product Options
  const chartOptions = chartData?.map(item => ({
    value: item.id,
    label: item.id + '-' + item.english,
  }))

  const filterProducts = (inputValue, options) => {
    return options.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const loadChartOptions = (inputValue, callback) => {
    if (inputValue) {
      callback(filterProducts(inputValue, chartOptions));
    } else {
      callback([]);
    }
  };



  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setAccount({ createdBy: createdBy })
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setAccount((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // handle select change
  const handleSelectChange = (selectedOption, name) => {

    setAccount((prev) => ({
      ...prev,
      [name]: selectedOption.value,
    }));

  };



  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        English: item.english,
        French: item.french, 
        Arabic: item.arabic,
        Nature: natureTextFormatter(item.isDebit, item),
        Type: item.type,
        Auxiliary: item.isAux,
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };


  let newColumnDefs = [
    { title: 'ID', dataIndex: 'accountId', width: '10%', sorter: true },
    { title: 'English', dataIndex: 'english' },
    { title: 'French', dataIndex: 'french' },
    { title: 'Arabic', dataIndex: 'arabic' },
    { title: 'Nature', dataIndex: 'isDebit', width: '10%', render: natureFormatter },
    { title: 'Type', dataIndex: 'type', width: '8%' },
    { title: 'Auxiliary', dataIndex: 'isAux', width: '8%', render: isAuxFormatter },
  ];

  useEffect(() => {
    setColumnDefs(newColumnDefs);
  }, []);

  const formView = (
    <div style={{ userSelect: 'none' }}>


      <Row className="mb-3">
        {/* Name  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Account<span style={{ color: 'red' }}> *</span></Form.Label>
          <AsyncSelect
            cacheOptions
            loadOptions={loadChartOptions}
            defaultOptions={[]}
            onChange={(e) => handleSelectChange(e, 'chartId')}
            value={chartOptions?.find(option => option.value === account.chartId)}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Form.Group>


      </Row>

      <Row className="mb-3">

        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Registration Number<span style={{ color: 'red' }}></span></Form.Label>
          <Form.Control type="text" name='registration'
            value={account.registration}
            onChange={handleInputChange}
          />
        </Form.Group>


      </Row>

      <Row className="mb-3">
        {/* Name  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Name<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control type="text" name='name'
            value={account.name}
            onChange={handleInputChange}
            required
          />
        </Form.Group>

        {/* Phone  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Phone</Form.Label>
          <Form.Control type="text" name='phone'
            value={account.phone}
            onChange={handleInputChange}
          />
        </Form.Group>


      </Row>

      <Row className="mb-3">
        {/* Address  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Address</Form.Label>
          <Form.Control as="textarea" name='address'
            value={account.address}
            onChange={handleInputChange}
          />
        </Form.Group>


        {/* Details  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Details</Form.Label>
          <Form.Control as="textarea" name='details'
            value={account.details}
            onChange={handleInputChange}
          />
        </Form.Group>

      </Row>

    </div >);


  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <></>
  );


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-0 mb-3'>
            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={8}>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>
          </Row>


          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            height={true}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />


          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'md'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, account }}
          />




        </>
      }

    </div>
  )
}

export default ChartTable;
